import Link from 'components/Link'

type NavItem = {
  label: string
  path: string
}

type TableOfContentsProps = {
  title: string
  navItems: NavItem[]
}

const TableOfContents = ({ title, navItems }: TableOfContentsProps) => (
  <nav>
    <h2 className='mc-text-h4'>{title}</h2>
    <ul className='mc-mt-3'>
      {navItems
        .filter((item) => item.label && item.path)
        .map((navItem) => (
          <li className='mc-mt-3' key={navItem.label}>
            <Link className='mc-text--link' href={navItem.path} isBasic>
              {navItem.label}
            </Link>
          </li>
        ))}
    </ul>
  </nav>
)

export default TableOfContents
